"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isEmptyObject_1 = require("./isEmptyObject");
/**
 * Strips all falsy and empty {} from a given object. Returns a new object with only truthy values.
 * Sourced from below but modified to include checks for empty object and ignoring keys.
 * https://www.w3resource.com/javascript-exercises/javascript-array-exercise-47.php
 *
 * @param obj
 * @param ignoreKeys
 */
const deepCompact = (obj, ignoreKeys) => {
    if (!obj) {
        return obj;
    }
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (Boolean(value) && !(0, isEmptyObject_1.default)(value) && !(ignoreKeys === null || ignoreKeys === void 0 ? void 0 : ignoreKeys.includes(key))) {
            acc[key] = typeof value === 'object' ? deepCompact(value, ignoreKeys) : value;
        }
        return acc;
    }, {});
};
exports.default = deepCompact;
//# sourceMappingURL=deepCompact.js.map